export const userRole = {
  ADMIN: "admin",
  AFFILIATE: "affiliate",
  EDITOR: "editor",
};
